var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCourseDiarySvgrepoCom({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "course-diary-svgrepo-com 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.8327 9.50065V3.16732C15.8327 2.29287 15.1238 1.58398 14.2493 1.58398H4.74935C3.8749 1.58398 3.16602 2.29287 3.16602 3.16732V15.834C3.16602 16.7085 3.8749 17.4173 4.74935 17.4173H14.2493C15.1238 17.4173 15.8327 16.7085 15.8327 15.834V14.6465",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.291 1.58398V11.084L13.3138 8.70898L15.8327 11.084V3.95898",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseDiarySvgrepoCom);
export default __webpack_public_path__ + "static/media/course-diary-svgrepo-com.b214c5c515ce17f47c85ec79858e2370.svg";
export { ForwardRef as ReactComponent };